module.exports = __webpack_public_path__ + "4fb86e31fad423bbb47a97248132d69e.jpg";